import * as React from "react";
import {
    List,
    TextInput,
    SimpleForm,
    TextField,
    Edit,
    FunctionField,
    Datagrid,
    TopToolbar,
    Show,
    ShowButton,
    Toolbar,
    SaveButton,
    ReferenceManyField,
    required,
    NumberInput,
    TabbedShowLayout
} from 'react-admin';

import { RichTextInput } from 'ra-input-rich-text';
import { EditableDatagrid, RowForm } from "@react-admin/ra-editable-datagrid";

import { iconStyle } from '../shared/Styles/iconsStyles';
import { fieldTabForShow } from '../shared/Styles/fieldsStyles';

import Typography from "@material-ui/core/Typography";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import NoteIcon from '@mui/icons-material/Note';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import Button from '@mui/material/Button';
import BusinessIcon from '@mui/icons-material/Business';
import QuizIcon from '@mui/icons-material/Quiz';
// import Avatar from '@mui/material/Avatar';
// import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

// Importo il css per i Bottoni
import { saveButtonCss, showButtonCss } from '../shared/Styles/buttonStyles';
import { listCss } from '../shared/Styles/listStyles';

/* TODO: da creare componente custom */
/* const CustomAvatarImage = ({ source, label }) => {
    const record = useRecordContext();
    if (!record) return null;

    return (
        <Box height="80%" width="80%" display="flex" justifyContent="left" alignItems="top">
            {record[source] ? (
                // <img src={customerImageUrl} alt="Logo cliente" style={{ maxHeight: '80%', maxWidth: '80%', marginTop: '25px', marginBottom: '25px' }} />
                <Avatar alt={label} style={{ width: '100px', height: '100px' }} src={record[source]} />
            ) : (
                <p><Avatar alt="Immagine mancante" style={{ width: '100px', height: '100px' }}><ImageNotSupportedIcon /></Avatar></p>
            )}
        </Box>
    );
}; */

/* const ListActions = () => (
    <TopToolbar>
        <SelectColumnsButton sx={columnsButtonCss} />
    </TopToolbar>
); */

export const MacroareeList = props => {

    return (
        <List
            pagination={null}
            title={<>
                <Button>
                    &nbsp;Macroarea
                </Button>
            </>}
            exporter={false}
            // aside={<MacroareaFilterSidebar />}
            {...props}
            actions={null}
            perPage={100}
        // filters={aziendaFilters}
        >
            <Datagrid sx={listCss} bulkActionButtons={false}>
                {/*<WrapperField label="Logo Macro Area">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                        <CustomAvatarImage source="urlLogo" label="Logo" ></CustomAvatarImage>
                    </Box>
                </WrapperField> */}
                {<FunctionField source="descrizione" render={record => record && <strong>{record.descrizione}</strong>} />}
                {<TextField label="Descizione Lunga" source="descrizioneLunga" />}
                {/* {<RichTextField label="Ordinamento" source="Ordinamento" />} */}
                {/* {<EditButton sx={editButtonCss} label="Modifica" />} */}
                {<ShowButton sx={showButtonCss} label="Dettaglio" />}
            </Datagrid>
        </List>
    );
}

/* const ShowActions = () => (
    <TopToolbar>
        <EditButton sx={editButtonCss} label="Modifica" />
    </TopToolbar>
);
 */

const MiaRowForm = () => (
    <RowForm>
        <TextField source="id" />
        <NumberInput min={0} label="Punteggio Risposte" source="punteggioRisposte" validate={required()} />
        <NumberInput min={0} label="Valore Assegnato" source="valoreAssegnato" validate={required()} />
    </RowForm>
);

export const MacroareeShow = (props) => {
    return (
        <Show title={<>
            <Button>
                &nbsp;Dettaglio Macro Area
            </Button>
        </>} /* actions={<ShowActions />} */ actions={null}>


            {/*                 <Grid item xs={12}>
                    <Card sx={{ minWidth: 275 }}>
                        <CardContent>
                            <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                                </Box>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
            <Grid item xs={12}>
                <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                        <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                <GpsFixedIcon sx={iconStyle} />
                                Descrizione: <FunctionField source="descrizione" render={record => record && `${record.descrizione}`} />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, my: 1 }}>
                                <NoteIcon />
                                Descrizione Lunga: <TextField label="Descrizione Lunga" source="descrizioneLunga" />
                            </Box>
                        </Typography>
                    </CardContent>
                </Card>
            </Grid>
            <TabbedShowLayout>
                <TabbedShowLayout.Tab label="Domante" sx={fieldTabForShow} icon={<QuizIcon sx={iconStyle} />}>

                    <Grid item xs={12}>
                        <ReferenceManyField
                            reference="tbl-domande"
                            target="tblMacroareeId"
                            // perPage={1}
                            sort={{ field: 'id', order: 'ASC' }}
                        >

                            <Datagrid
                                noDelete
                                bulkActionButtons={false}
                            /* createForm={null} editForm={<MiaRowForm />} */
                            >
                                {/* <TextField source="id" /> */}
                                {/* <TextField source="tblMacroareeId" validate={required()} /> */}
                                <TextField source="codiceDomanda" />
                                <TextField source="descrizione" />
                            </Datagrid>

                        </ReferenceManyField>
                    </Grid>
                </TabbedShowLayout.Tab>



                <TabbedShowLayout.Tab label="Ponderali" sx={fieldTabForShow} icon={<GpsFixedIcon sx={iconStyle} />}>

                    <Grid item xs={12}>
                        {/*                         <Card sx={{ minWidth: 275 }}>
                            <CardContent>
                                <Typography sx={{ mb: 1.5, color: 'text.secondary' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#e85a2c' }}>
                                        <GpsFixedIcon sx={iconStyle} />
                                        Ponderali
                                    </Box>
                                </Typography>
                            </CardContent>
                        </Card> */}
                        <ReferenceManyField
                            reference="tbl-macroarea-punteggio"
                            target="tblMacroareeId"
                            // perPage={1}
                            sort={{ field: 'id', order: 'ASC' }}
                        >

                            <Datagrid
                                noDelete
                                bulkActionButtons={false}
                            // createForm={null} editForm={<MiaRowForm />}
                            >
                                {/* <TextField source="id" /> */}
                                {/* <TextField source="tblMacroareeId" validate={required()} /> */}
                                <TextField source="punteggioRisposte" validate={required()} />
                                <TextField source="valoreAssegnato" validate={required()} />
                            </Datagrid>

                        </ReferenceManyField>
                    </Grid>
                </TabbedShowLayout.Tab>
            </TabbedShowLayout>
        </Show>
    );
}

const ShowTopToolbarDettaglio = () => (
    <TopToolbar>
        <ShowButton sx={showButtonCss} label="Dettaglio" />
    </TopToolbar>
);

const ShowActionsForEdit = () => (
    <ShowTopToolbarDettaglio></ShowTopToolbarDettaglio>
);

const MyToolbarEdit = () => (
    <Toolbar>
        <SaveButton sx={saveButtonCss} /* sx={{
            border: 1,
            borderColor: 'black',
            borderRadius: '20px',
            backgroundColor: '#01b5d0'
        }} */ label="Salva parametri" alwaysEnable />
    </Toolbar>
);

export const MacroareeEdit = (props) => (
    <Edit actions={<ShowActionsForEdit />} title="Modifica Macroarea" {...props}>
        <SimpleForm toolbar={<MyToolbarEdit />}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Card sx={{ minWidth: 275, boxShadow: 3 }}>
                        <CardContent>
                            <Typography component="div">
                                <Grid container spacing={2}>
                                    {[
                                        { icon: PersonIcon, label: 'Nome', source: 'nome', component: TextInput },
                                        { icon: BusinessIcon, label: 'Ragione Sociale Completa', source: 'ragioneSociale', component: TextInput },
                                        { icon: BusinessIcon, label: 'Partita Iva', source: 'partitaIva', component: TextInput },
                                        { icon: PersonIcon, label: 'Nome referente', source: 'nomeReferente', component: TextInput },
                                        { icon: PhoneIcon, label: 'Telefono', source: 'telefono', component: TextInput },
                                        { icon: PhoneIcon, label: 'Cellulare', source: 'cellulare', component: TextInput },
                                        { icon: EmailIcon, label: 'Email', source: 'email', component: TextInput },
                                        { icon: HomeIcon, label: 'Indirizzo', source: 'indirizzo', component: TextInput },
                                        /* {
                                            icon: PublicIcon, label: 'Zona', source: 'zona', component: SelectInput, choices: [
                                                { id: 'n', name: 'Nord' }, { id: 'no', name: 'Nord-Ovest' }, { id: 'ne', name: 'Nord-Est' },
                                                { id: 'e', name: 'Est' }, { id: 'o', name: 'Ovest' }, { id: 'so', name: 'Sud-Ovest' },
                                                { id: 'se', name: 'Sud-Est' }, { id: 's', name: 'Sud' },
                                            ]
                                        }, */
                                        { icon: NoteIcon, label: 'Note', source: 'note', component: RichTextInput },
                                        { icon: GpsFixedIcon, label: 'Longitudine', source: 'longitudine', component: TextInput },
                                        { icon: GpsFixedIcon, label: 'Latitudine', source: 'latitudine', component: TextInput },
                                    ].map((field, index) => (
                                        <Grid item xs={12} sm={index < 8 ? 6 : 12} key={field.label}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                                {React.createElement(field.icon, { sx: { color: 'action.active', mr: 1, my: 0.5, fontSize: '1.25rem' } })}
                                                {React.createElement(field.component, {
                                                    label: field.label,
                                                    source: field.source,
                                                    ...(field.choices ? { choices: field.choices } : {}),
                                                    sx: { width: '100%' },
                                                })}
                                            </Box>
                                        </Grid>
                                    ))}

                                </Grid>
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </SimpleForm>
    </Edit>
);



